import { render, staticRenderFns } from "./goodsData.vue?vue&type=template&id=ec949b58&scoped=true"
import script from "./goodsData.vue?vue&type=script&lang=js"
export * from "./goodsData.vue?vue&type=script&lang=js"
import style0 from "./goodsData.vue?vue&type=style&index=0&id=ec949b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec949b58",
  null
  
)

export default component.exports